import 'react-app-polyfill/ie11';
import "./legay/Polyfills";

import * as React from "react";
import * as ReactDOM from "react-dom";

import {PartnerLoginForm} from "./components/PartnerLoginForm";
import {PaymentReservationPin} from "./components/PaymentReservationPin";
import {TeamsChannelSelector} from "./components/TeamsChannelSelector";
import {MagazineWidget} from "./components/MagazineWidget";
import {Newsletter} from "./components/Newsletter";
import MagazineAdmin from "./components/magazine/MagazineAdmin";
import {CustomerPortalLogin} from "./components/CustomerPortalLogin";
import FreeApartments from "./components/rental/FreeApartments";
import {Option} from "./components/Select";
import JobApplicationForm from "./components/JobApplicationForm";
import PartnerPortalLogin from "./components/partnerPortal/Login";
import Chat from "./components/chat/Chat";
import {Map} from "./components/Map/Map";
import {mapMarkerStyleBlack} from "./components/Map/MapMarker";
import PreferentialOccupancy from "./components/PreferentialOccupancy/PreferentialOccupancy";

(window as any).react = {

    react_partner_login_form: function (target: any) {
        if (target) {
            return ReactDOM.render(
                <PartnerLoginForm/>,
                target
            );
        }
    },

    react_teams_channel_selector: function (target: any) {
        if (target) {
            return ReactDOM.render(
                <TeamsChannelSelector label={target.getAttribute('data-label')}
                                      name={target.getAttribute('data-name')}
                                      value={target.getAttribute('data-value')}/>,
                target
            );
        }
    },

    react_payment_reservation_pin: function (target: any, status: string, downloadUrl: string) {
        if (target) {
            return ReactDOM.render(
                <PaymentReservationPin status={status} downloadUrl={downloadUrl}/>,
                target
            );
        }
    },

    react_magazine_widget: function (target: any, type: string, showHeader: string, articles: string, numberOfArticles: number) {
        if (target) {
            return ReactDOM.render(
                <MagazineWidget type={type} showHeader={showHeader == '1'} articles={articles + ""}
                                numberOfArticles={numberOfArticles as number}/>,
                target
            );
        }
    },

    react_magazine_admin: function (target: any, multi: boolean) {
        if (target) {
            return ReactDOM.render(
                <MagazineAdmin limit={15} multi={multi}/>,
                target
            );
        }
    },

    react_customer_portal_login: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <CustomerPortalLogin config={config}/>,
                target
            );
        }
    },

    react_rental_portal_free_apartments: function (target: any, houseId: number, baseUrl: string, language: string) {
        if (target) {
            return ReactDOM.render(
                <FreeApartments baseUrl={baseUrl} houseId={houseId} lang={language}/>,
                target
            );
        }
    },

    react_newsletter: function (target: any, id: string, key: string, type: number, unsubscribe: number) {
        if (target) {
            return ReactDOM.render(
                <Newsletter id={id} hash={key} type={type} unsubscribe={unsubscribe}/>,
                target
            );
        }
    },

    react_render_job_application: function (target: any, title: string, attentiveThroughList: Option[], showFileUpload: boolean) {
        if (target) {
            return ReactDOM.render(
                <JobApplicationForm title={title} attentiveThroughList={attentiveThroughList} showFileUpload={showFileUpload}/>,
                target
            );
        }
    },

    react_partner_portal_login: function (target: any) {
        if (target) {
            return ReactDOM.render(
                <PartnerPortalLogin />,
                target
            );
        }
    },

    react_chat: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <Chat config={config.config} />,
                target
            );
        }
    },

    react_map: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <Map defaultZoom={config.defaultzoom} center={{lat: config.lat + 0.3, lng: config.lng}} openPopupOnStart={config.openpopuponstart}
                     minLabelOccurrenceForLabelFilter={[]}
                     legend={null}
                     mapMarkers={[
                    {
                        lat: config.lat,
                        lng: config.lng,
                        title: config.title ?? '',
                        label: config.label ?? [],
                        content: config.content ?? [],
                        image: config.image ?? '',

                        icons: [
                            {
                                label: [],
                                style: mapMarkerStyleBlack(),
                                visible: true
                            }
                        ],
                    },
                ]} />,
                target
            );
        }
    },

    react_preferential_occupancy: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <PreferentialOccupancy mapMarkers={config.mapMarkers} />,
                target
            );
        }
    },
}
